// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  background-color: #00BCD4;
  box-shadow: var(--shadow-md);
  padding: 0;
  position: relative;
  z-index: 1000;
  flex-shrink: 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  height: 72px;
  width: 100%;
  padding: 0 24px;
}

.logo-section {
  cursor: pointer;
  transition: var(--transition);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  min-width: 0;
  max-width: 50%; /* 限制logo区域最大宽度，为搜索框留出空间 */
}

.logo-section:hover {
  opacity: 0.8;
}

.logo-icon {
  display: block;
  height: 32px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  flex-shrink: 0;
}

.logo-icon-default {
  font-size: 24px;
  color: var(--color-primary);
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.site-title {
  margin: 0 0 0 8px !important;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.search-section {
  max-width: 400px;
  min-width: 300px;
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1;
}

.search-wrapper {
  width: 100%;
  position: relative;
}

.search-input {
  border-radius: 9999px !important;
  background-color: #f5f5f5 !important;
  border: none !important;
  padding: 8px 40px 8px 40px !important; /* 为前缀和后缀图标留出空间 */
  font-size: 14px;
  transition: var(--transition);
  height: 40px;
  width: 100% !important;
}

.search-prefix-icon {
  color: #999;
  font-size: 16px;
}

.search-clear-icon {
  color: #999;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.search-clear-icon:hover {
  background-color: #e0e0e0;
  color: #666;
}

.search-input:focus {
  background-color: var(--color-bg-white) !important;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2) !important;
}

.search-input:hover {
  background-color: #f0f0f0 !important;
}

.search-button {
  color: #999 !important;
  transition: var(--transition);
  position: absolute !important;
  right: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.search-button:hover {
  color: var(--color-primary) !important;
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 16px;
    justify-content: center; /* 居中显示logo和title */
  }

  /* PAD端：隐藏搜索框，只显示logo和title */
  .search-section {
    display: none;
  }

  .site-title {
    display: block; /* 显示title */
    font-size: 18px;
  }

  .logo-section {
    max-width: none;
    flex-shrink: 0;
  }

  .logo-icon {
    max-width: 160px;
  }
}

@media (max-width: 480px) {
  .app-header {
    height: 56px;
    line-height: normal;
  }

  .header-content {
    padding: 0 12px;
    height: 56px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .logo-section {
    display: flex;
    width: 112px;
    max-width: 112px;
    min-width: 112px;
    flex: 0 0 112px;
    align-items: center;
    justify-content: flex-start;
    line-height: normal;
  }

  .site-title {
    display: none !important;
  }

  .logo-section .ant-space {
    gap: 0 !important;
  }

  .logo-icon {
    width: 104px;
    height: auto;
    max-width: 104px;
    max-height: 32px;
  }

  .logo-icon-default {
    width: 32px;
    height: 32px;
  }

  .search-section {
    display: flex;
    width: auto;
    max-width: none;
    min-width: 0;
    margin-left: 0;
    flex: 1 1 auto;
    justify-content: center;
    line-height: normal;
  }

  .search-wrapper {
    width: 100%;
    max-width: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC,EAAE,iBAAiB;EACxD,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB,EAAE,mBAAmB;EAC9C;;EAEA,6BAA6B;EAC7B;IACE,aAAa;EACf;;EAEA;IACE,cAAc,EAAE,YAAY;IAC5B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".app-header {\n  background-color: #00BCD4;\n  box-shadow: var(--shadow-md);\n  padding: 0;\n  position: relative;\n  z-index: 1000;\n  flex-shrink: 0;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  height: 72px;\n  width: 100%;\n  padding: 0 24px;\n}\n\n.logo-section {\n  cursor: pointer;\n  transition: var(--transition);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  color: inherit;\n  text-decoration: none;\n  min-width: 0;\n  max-width: 50%; /* 限制logo区域最大宽度，为搜索框留出空间 */\n}\n\n.logo-section:hover {\n  opacity: 0.8;\n}\n\n.logo-icon {\n  display: block;\n  height: 32px;\n  width: auto;\n  max-width: 180px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.logo-icon-default {\n  font-size: 24px;\n  color: var(--color-primary);\n  height: 32px;\n  width: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.site-title {\n  margin: 0 0 0 8px !important;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.search-section {\n  max-width: 400px;\n  min-width: 300px;\n  margin-left: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n}\n\n.search-wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.search-input {\n  border-radius: 9999px !important;\n  background-color: #f5f5f5 !important;\n  border: none !important;\n  padding: 8px 40px 8px 40px !important; /* 为前缀和后缀图标留出空间 */\n  font-size: 14px;\n  transition: var(--transition);\n  height: 40px;\n  width: 100% !important;\n}\n\n.search-prefix-icon {\n  color: #999;\n  font-size: 16px;\n}\n\n.search-clear-icon {\n  color: #999;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.search-clear-icon:hover {\n  background-color: #e0e0e0;\n  color: #666;\n}\n\n.search-input:focus {\n  background-color: var(--color-bg-white) !important;\n  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2) !important;\n}\n\n.search-input:hover {\n  background-color: #f0f0f0 !important;\n}\n\n.search-button {\n  color: #999 !important;\n  transition: var(--transition);\n  position: absolute !important;\n  right: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.search-button:hover {\n  color: var(--color-primary) !important;\n}\n\n@media (max-width: 768px) {\n  .header-content {\n    padding: 0 16px;\n    justify-content: center; /* 居中显示logo和title */\n  }\n\n  /* PAD端：隐藏搜索框，只显示logo和title */\n  .search-section {\n    display: none;\n  }\n\n  .site-title {\n    display: block; /* 显示title */\n    font-size: 18px;\n  }\n\n  .logo-section {\n    max-width: none;\n    flex-shrink: 0;\n  }\n\n  .logo-icon {\n    max-width: 160px;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-header {\n    height: 56px;\n    line-height: normal;\n  }\n\n  .header-content {\n    padding: 0 12px;\n    height: 56px;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .logo-section {\n    display: flex;\n    width: 112px;\n    max-width: 112px;\n    min-width: 112px;\n    flex: 0 0 112px;\n    align-items: center;\n    justify-content: flex-start;\n    line-height: normal;\n  }\n\n  .site-title {\n    display: none !important;\n  }\n\n  .logo-section .ant-space {\n    gap: 0 !important;\n  }\n\n  .logo-icon {\n    width: 104px;\n    height: auto;\n    max-width: 104px;\n    max-height: 32px;\n  }\n\n  .logo-icon-default {\n    width: 32px;\n    height: 32px;\n  }\n\n  .search-section {\n    display: flex;\n    width: auto;\n    max-width: none;\n    min-width: 0;\n    margin-left: 0;\n    flex: 1 1 auto;\n    justify-content: center;\n    line-height: normal;\n  }\n\n  .search-wrapper {\n    width: 100%;\n    max-width: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
